import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { InfoText, InfoType } from '../General/InfoText';
import { CheckBox } from '../General/Checkbox';
import { Input } from '../General/Input';
import { FormInput, FormWrapper } from '../Form/FormInput';
import { Select } from '../General/Select';
import { StreetAndNumber } from '../Form/StreetAndNumber';
import { CityZip } from '../Form/CityZip';
import { Address } from '../Form/Address';

interface Props {
  street: string;
  streetNumber: string;
  city: string;
  zip: string;
  country: string;
  onChange: any;
}

function InvoiceAddressBlock({
  street,
  streetNumber,
  city,
  zip,
  country,
  onChange,
}: Props) {
  return (
    <Wrapper>
      <Address
        street={street}
        streetNumber={streetNumber}
        city={city}
        zip={zip}
        onChange={onChange}
      />
      <Select
        marginBottom={8}
        name="country"
        label={__('Krajina')}
        value={country}
        options={[{ value: 'sk', name: 'Slovensko' }]}
        // tslint:disable-next-line:jsx-no-lambda
        onChange={onChange}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  padding: ${rem(42)} ${rem(32)} ${rem(32)};

  ${({ theme }) => theme.mediab.m600`
    padding: ${rem(42)} ${rem(16)} ${rem(32)};
  `}
`;

export { InvoiceAddressBlock };
